import { render, staticRenderFns } from "./CustomerClosedTicketView.vue?vue&type=template&id=45750d14&"
import script from "./CustomerClosedTicketView.vue?vue&type=script&lang=js&"
export * from "./CustomerClosedTicketView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerClosedTicketView.vue?vue&type=style&index=0&id=45750d14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports